import React from 'react';
import './Notifications.css';

const Notifications = (props) => {
  let error;
  let micNote;
  let versionNote;
  const isChrome = navigator.userAgent.match(/Chrome\/(\S+)/);
  let version;

  if (props.config.environment === 'desktop' &&
      props.deviceConfig.supportsRecording && !props.deviceConfig.allowsRecording) {
    micNote = <div>Please give the browser a permission to use your microphone.</div>;
  }

  if (isChrome) {
    version = isChrome[1].substring(0, isChrome[1].indexOf('.'));

    if (version < 53) {
      versionNote = (<div>
        You are using Chrome {version}, which is outdated.
        Please update your browser to use Pronounce Live.
      </div>
    );
    }
  }

  if (props.errorMessage) {
    error = <div>{props.errorMessage}</div>;
  }

  return <div className="pronounce-notifications">{error}{micNote}{versionNote}</div>;
};

export default Notifications;



// WEBPACK FOOTER //
// ./src/components/Notifications.js